import { createReducer } from 'reduxsauce';
import { DOCTORS_URL } from 'src/services/api/urls';
import history from 'src/services/browser-history';
import { DoctorReducerTypes } from '../types';

import Types from './actions-types';

export const INITIAL_STATE: DoctorReducerTypes = {
  list: [],
  created: [],
  pagination: {
    count: 8,
    total: 8,
    page: 1,
    filter: '',
    s: null,
  },
  isLoading: false,
  hasError: false,
};

export const createRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const createRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const list = [...state.created] as any;
  const { doctor } = action;

  list.unshift(doctor);

  return {
    ...state,
    list: [],
    created: list,
    isLoading: false,
    hasError: false,
  };
};

export const createRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const deleteRequest = (state = INITIAL_STATE, action: any) => {
  const id = action.id;
  const list = state.list.filter((d: any) => d.id.toString() !== id.toString());
  return {
    ...state,
    list,
    isLoading: true,
  };
};

export const deleteRequestSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: false,
  };
};

export const deleteRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const updateRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const updateRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { doctor } = action;
  const list = state.list.map((d: any) => {
    if (d.id.toString() === doctor.id.toString()) {
      return { ...d, ...doctor };
    }
    return d;
  });

  return {
    ...state,
    list,
    isLoading: false,
    hasError: false,
  };
};

export const updateRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const listRequest = (state = INITIAL_STATE, action: any) => {
  state.list = [];
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const listRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { data, ...pagination } = action.data;

  return {
    ...state,
    created: [],
    list: data,
    pagination: { ...state.pagination, ...pagination },
    isLoading: false,
    hasError: false,
  };
};

export const listRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const uploadRequest = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const uploadRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { data, ...pagination } = action;

  return {
    ...state,
    list: data,
    pagination: { ...state.pagination, ...pagination },
    isLoading: false,
    hasError: false,
  };
};

export const uploadRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const getRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const getRequestSuccess = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    item: action.data.data,
    isLoading: false,
    hasError: false,
  };
};

export const getRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const clearStore = (state = INITIAL_STATE) => {
  if (
    DOCTORS_URL.includes(history.location.pathname.split('/')[1]) &&
    history.location.search !== ''
  ) {
    return { ...INITIAL_STATE, pagination: state.pagination };
  }
  return INITIAL_STATE;
};

export const HANDLERS = {
  [Types.DOCTORS_CREATE_REQUEST as string]: createRequest,
  [Types.DOCTORS_CREATE_REQUEST_SUCCESS as string]: createRequestSuccess,
  [Types.DOCTORS_CREATE_REQUEST_ERROR as string]: createRequestError,

  [Types.DOCTORS_DELETE_REQUEST as string]: deleteRequest,
  [Types.DOCTORS_DELETE_REQUEST_SUCCESS as string]: deleteRequestSuccess,
  [Types.DOCTORS_DELETE_REQUEST_ERROR as string]: deleteRequestError,

  [Types.DOCTORS_UPDATE_REQUEST as string]: updateRequest,
  [Types.DOCTORS_UPDATE_REQUEST_SUCCESS as string]: updateRequestSuccess,
  [Types.DOCTORS_UPDATE_REQUEST_ERROR as string]: updateRequestError,

  [Types.DOCTORS_LIST_REQUEST as string]: listRequest,
  [Types.DOCTORS_LIST_REQUEST_SUCCESS as string]: listRequestSuccess,
  [Types.DOCTORS_LIST_REQUEST_ERROR as string]: listRequestError,

  [Types.DOCTORS_UPLOAD_REQUEST as string]: uploadRequest,
  [Types.DOCTORS_UPLOAD_REQUEST_SUCCESS as string]: uploadRequestSuccess,
  [Types.DOCTORS_UPLOAD_REQUEST_ERROR as string]: uploadRequestError,

  [Types.DOCTORS_GET_REQUEST as string]: getRequest,
  [Types.DOCTORS_GET_REQUEST_SUCCESS as string]: getRequestSuccess,
  [Types.DOCTORS_GET_REQUEST_ERROR as string]: getRequestError,

  [Types.CLEAR_STORE as string]: clearStore,
};

export default createReducer(INITIAL_STATE, HANDLERS);
